// Silently capture marketing attribution (UTM params, gclid, fbclid) on first
// visit and persist it for the session so it can be attached to lead submissions.

const KEY = "pryme_attribution";
const FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "fbclid",
];

// Read attribution from the current URL and store it (first-touch wins).
export const captureAttribution = () => {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem(KEY) || "{}");
    let changed = false;
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v && !stored[f]) {
        stored[f] = v;
        changed = true;
      }
    });
    if (changed) sessionStorage.setItem(KEY, JSON.stringify(stored));
  } catch (e) {
    /* noop */
  }
};

export const getAttribution = () => {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch (e) {
    return {};
  }
};
